import { render, staticRenderFns } from "./ChoixCerfa.vue?vue&type=template&id=6cf38ace"
import script from "./ChoixCerfa.vue?vue&type=script&lang=js"
export * from "./ChoixCerfa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports